import fetch from "isomorphic-fetch";
import { filter } from "ramda";
import { validatedDate } from "redux/helpers";

export default class API {
  static create({ start, stop, site_id = "", name = "" }) {
    const dates = filter(Boolean, {
      start: validatedDate(start),
      stop: validatedDate(stop)
    });

    const request = new Request(`/api/sites/${site_id}/${name}`, {
      method: "POST",
      credentials: "include",
      headers: {
        "Content-Type": "application/json"
      },
      body: JSON.stringify({
        ...dates
      })
    });

    return fetch(request);
  }
}
